module.exports = "<p>\r\n  awsop-lab14 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab14/awsop-lab14.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab14/awsop-lab14.component.html
// module chunks = main